import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
var Blockquote = /*#__PURE__*/_createClass(function Blockquote(options) {
  _classCallCheck(this, Blockquote);
  this.type = options.type || 'blockquote';
  this.children = options.children || [{
    text: ''
  }];
});
var generateBlockquote = function generateBlockquote(options) {
  return Object.assign({}, new Blockquote(options));
};
export default generateBlockquote;